import { useState } from "react";
import { toast } from "sonner";
import { Check, Heart } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const THANKS = ["Thank you for being in my corner 💜", "Your support means more than you know", "So glad you're here with me on this journey"];

// Renew a supporter's link, optionally adding a thank-you to their renewal email
export const RenewDialog = ({ supporter, onClose, onDone }) => {
  const [pick, setPick] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const withThanks = pick !== null || note.trim();

  const renew = async (thank) => {
    setBusy(true);
    try {
      const body = thank ? { thanks: pick, note: note.trim() || null } : {};
      const { data } = await api.post(`/supporters/${supporter.id}/renew`, body);
      toast.success(data.thanked ? `Renewed and thank-you sent to ${supporter.name} 💜` : `${supporter.name}'s link renewed for 90 days`);
      onDone?.();
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={!!supporter} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="renew-dialog">
        <DialogHeader>
          <DialogTitle>Renew {supporter?.name}'s link</DialogTitle>
          <DialogDescription>Their same link works for 90 more days. Want to add a thank-you to the email they get?</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {THANKS.map((t, i) => (
            <button key={t} type="button" onClick={() => setPick(pick === i ? null : i)} data-testid={`renew-thanks-${i}`}
              className={`w-full text-left text-sm p-3 rounded-2xl border-2 flex items-center justify-between gap-2 transition-colors ${pick === i ? "border-mm-primary bg-mm-primary/15 font-semibold" : "border-transparent mm-soft"}`}>
              {t}{pick === i && <Check size={16} className="text-mm-primary shrink-0" data-testid={`renew-thanks-${i}-selected`} />}
            </button>
          ))}
          <textarea className="mm-input min-h-[70px] text-sm" maxLength={200} placeholder="Add a short note (optional)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="renew-note-input" />
          <div className="text-xs text-mm-muted text-right">{note.length}/200</div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <button className="mm-btn flex-1 !py-2.5 text-sm" disabled={busy || !withThanks} onClick={() => renew(true)} data-testid="renew-send-thanks-btn"><Heart size={14} />Renew &amp; send thank-you</button>
          <button className="mm-btn-ghost flex-1 !py-2.5 text-sm" disabled={busy} onClick={() => renew(false)} data-testid="renew-only-btn">Just renew</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
